import { render, staticRenderFns } from "./ModalPaymentImage.vue?vue&type=template&id=6a0b2056&scoped=true"
import script from "./ModalPaymentImage.vue?vue&type=script&lang=js"
export * from "./ModalPaymentImage.vue?vue&type=script&lang=js"
import style0 from "./ModalPaymentImage.vue?vue&type=style&index=0&id=6a0b2056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b2056",
  null
  
)

export default component.exports